import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { IUserRegisterRequest } from "../../../types/apis/profile";

export const UserRegister = async ({
  payload,
  token,
}: {
  payload: FormData;
  token: Token;
}): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<IUserRegisterRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.userRegister,
      body: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useUserRegister = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: FormData; token: Token }
  > = useMutation({
    mutationFn: UserRegister,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
